import { lazy, Suspense } from "react";
// import Feedback from "./Feedback";
import FindMyCar from "./FindMyCar";
import Offers from "./Offers";
import { IoCloseSharp } from "react-icons/io5";
import { Button } from "./ui/button";
import useMapStore from "@/store/mapStore";
import { AnimatePresence, motion } from "framer-motion";
import { cn } from "@/lib/utils";
const Feedback = lazy(() => import("./Feedback.js"));

function Overlay({
  content,
}: {
  content: "findMyCar" | "offers" | "feedback";
}) {
  const mobileMode = useMapStore((state) => state.mobileMode);
  const setOverlayContent = useMapStore((state) => state.setOverlayContent);
  const setActiveMenuItem = useMapStore((state) => state.setActiveMenuItem);

  const closeHandler = () => {
    setOverlayContent(undefined);
    setActiveMenuItem("map");
  };

  return (
    <AnimatePresence>
      <motion.div
        key="overlay"
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0 }}
        transition={{ duration: 0.2 }}
        className={cn(
          "fixed z-100 h-full w-full bg-white p-10",
          mobileMode && "px-4 pb-20 pt-16",
          "z-[102]",
          content === "feedback" && "p-0",
        )}
        style={{
          //@ts-expect-error color
          "--custom-handle-bg": `var(--primary)`,
        }}
      >
        <Button
          onClick={closeHandler}
          size="icon"
          className={cn(
            "absolute top-10 z-100 h-12 w-12 rounded-xl group-data-[dir=ltr]:right-10 group-data-[dir=rtl]:left-10",
            mobileMode &&
              "top-5 h-8 w-8 rounded-lg text-lg group-data-[dir=ltr]:right-5 group-data-[dir=rtl]:left-5",
          )}
        >
          <IoCloseSharp />
        </Button>
        {content === "findMyCar" && <FindMyCar />}
        {content === "offers" && <Offers />}
        {content === "feedback" && (
          <Suspense>
            <Feedback />
          </Suspense>
        )}
      </motion.div>
    </AnimatePresence>
  );
}

export default Overlay;
